import { render, staticRenderFns } from "./fireFightingTrainingScenarioDetail.vue?vue&type=template&id=33000473"
import script from "./fireFightingTrainingScenarioDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingTrainingScenarioDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33000473')) {
      api.createRecord('33000473', component.options)
    } else {
      api.reload('33000473', component.options)
    }
    module.hot.accept("./fireFightingTrainingScenarioDetail.vue?vue&type=template&id=33000473", function () {
      api.rerender('33000473', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/scenario/fireFightingTrainingScenarioDetail.vue"
export default component.exports